<script setup lang="ts">
type Props = {
  name: string
  modelValue: any
  rules?: string
}

const props = withDefaults(
  defineProps<Props>(), { rules: '' },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()

const innerValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<template>
  <ValidationField
    v-slot:default="{ errors, handleChange }"
    v-bind:model-value="innerValue"
    class="c-validationTextField"
    v-bind:name="name"
    v-bind:rules="rules"
  >
    <v-select
      v-bind:name="name"
      v-bind:model-value="innerValue"
      v-bind:error-messages="errors"
      v-bind="$attrs"
      v-on:update:model-value="
        (v: string) => {
          handleChange(v, errors.length > 0)
          emit('update:modelValue', v)
        }
      "
      v-on:blur="handleChange"
    />
  </ValidationField>
</template>

<style lang="scss" scoped>
.c-validationTextField {
  &:deep(.v-input) {
    fieldset {
      border-width: 2px;
      border-radius: 6px;
      border-color: var(--color_border_control);
    }
  }

  &:deep(.v-input__slot) {
    min-height: 47px !important;
  }

  &:deep(.v-input__append-inner) {
    margin-top: 12px !important;
  }

  &:deep(.error--text) {
    fieldset {
      border-color: var(--color_border_control_error);
    }
  }
}
</style>
